"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.read_param = exports.parse_ack = void 0;
const bytes_deal_1 = require("./bytes_deal");
const LED_Head_TLV = 0x55AA;
const TYPE_CMD_TLV_Set = 0x02;
const TYPE_CMD_TLV_Get = 0x03;
const TYPE_CMD_TLV_Upgrade = 0x04;
const TYPE_CMD_TLV_Ack = 0x80;
const TYPE_UPLOAD = 0x06;
const TYPE_UPLOAD_GAME_Info = 0x0A;
const TLV_LED_Power = 0x04;
const TLV_LED_Light = 0x06;
const TLV_LED_Dev_Info = 0x0A;
const TLV_LED_Advance = 0x1B;
const TLV_LED_pgm_flicker = 0x2D;
const TLV_LED_Rotate = 0x2F;
const TLV_LED_bluetooth = 0x34;
const TLV_LED_pgm_key = 0x35;
const TLV_LED_pgm_play = 0x36;
const ACK_TLV_ERR_Unknown = 0xFF;
const Size_Min_Ack_Pkt_Tlv = 10;
const Size_Min_Ack_Get_Pkt_Tlv = 13;
function read_power(buf, len) {
    var type = buf[0];
    if (len < 2 || (0 != type && (type * 5 + 1) != len)) {
        console.log("read_power: tlv data err!\n");
        return null;
    }
    if (type > 0) {
        var weeks = buf[1];
        var week = [];
        for (var i = 0; i < 7; ++i) {
            if ((weeks & (1 << i)) > 0)
                week.push(i + 1);
        }
        var period = [];
        var pos = 2;
        for (var i = 0; i < type; ++i) {
            period.push(("0" + buf[pos]).substr(-2) + ":" + ("0" + buf[pos + 1]).substr(-2)
                + "-" + ("0" + buf[pos + 2]).substr(-2) + ":" + ("0" + buf[pos + 3]).substr(-2));
            pos += 5;
        }
        return { power: { type: 1, week: week, period: period } };
    }
    else
        return { power: { type: 0, value_fix: buf[1] } };
}
function read_light(buf, len) {
    var type = buf[0];
    if (len < 2 || (0 != type && (type * 3 + 1) != len)) {
        console.log("read_light: tlv data err\n");
        return null;
    }
    if (type == 0) {
        return { light: { type: 0, value_fix: buf[1] } };
    }
    else {
        var pos = 1;
        var period = [];
        for (var i = 0; i < type; i++) {
            period.push({
                value: buf[pos],
                time: ("0" + buf[pos + 1]).substr(-2) + ":" + ("0" + buf[pos + 2]).substr(-2)
            });
            pos += 3;
        }
        return { light: { type: 1, value_period: period } };
    }
}
function read_param_dev_ex(buf, len) {
    var type = buf[0];
    if (len < 5 || (0 == type && len < 16)) {
        console.log("read_param_dev_ex: tlv data err\n");
        return null;
    }
    var w = bytes_deal_1.bytes_read_int(buf, 1, 2, false);
    var h = bytes_deal_1.bytes_read_int(buf, 3, 2, false);
    if (0 == type) {
        var type_color = buf[7];
        if (type_color < 1)
            type_color = 1;
        var gray = buf[8] - 1;
        var typeScan = buf[9];
        var count_io = len - 16;
        console.log("type_scan:%d\n", typeScan);
        var decoder = 0;
        var polar_nodecoder = 0;
        if (typeScan >= 0x80) {
            decoder = 0;
            typeScan = 0xFF - typeScan + 0x80;
        }
        else if (typeScan > 21) {
            typeScan -= 21;
            var h1 = typeScan >> 4;
            var l = typeScan & 0x0F;
            typeScan = (l << 4) + (l == 0 ? h1 : (h1 + 1));
            decoder = 1;
        }
        else if (typeScan > 16) {
            typeScan -= 16;
            typeScan = (typeScan << 4) & 0xFF;
            polar_nodecoder = buf[10];
        }
        else {
            decoder = 1;
            typeScan = (typeScan << 4) & 0xFF;
        }
        var data_out = [];
        for (var i = 0; i < count_io; ++i)
            data_out.push(buf[16 + i]);
        return {
            param_dev: {
                width: w,
                height: h,
                polar_data: buf[5],
                polar_oe: buf[6],
                type_color: type_color,
                gray: gray,
                decoder: decoder,
                type_scan: typeScan,
                polar_nodecoder: polar_nodecoder,
                line_bank: buf[11],
                segment: buf[12],
                delay_frame: buf[13],
                rate_frame: buf[14],
                backgroup: buf[15],
                count_io: count_io,
                data_out: data_out
            }
        };
    }
    else
        return { param_dev: { width: w, height: h } };
}
function read_dev_info(buf) {
    var data = "";
    for (var i = 0; i < buf.length; i++)
        data += String.fromCharCode(buf[i]);
    var arr = data.split(",");
    if (arr.length == 5)
        return { dev_info: {
                id_dev: arr[0],
                version: arr[1] + "_" + arr[2],
                model: arr[3],
                expend: arr[4]
            } };
    else if (arr.length > 5)
        return { dev_info: {
                id_dev: arr[0],
                version: arr[1] + "_" + arr[2],
                model: arr[3],
                expend: arr[4],
                cid: arr[5]
            } };
    else
        return { dev_info: {
                id_dev: arr[0],
                version: arr[1] + "_" + arr[2],
                model: arr[3],
            } };
}
function read_pgm_flicker(buf) {
    if (buf.length != 6) {
        console.log("invalid pgm_flicker", buf);
        return null;
    }
    var ms = bytes_deal_1.bytes_read_int(buf, 2, 4, false);
    return { pgm_flicker: {
            type: buf[0],
            count_pgm: buf[1],
            time: ms
        } };
}
function read_param(tag, buf, len) {
    switch (tag) {
        case TLV_LED_Advance:
            return read_param_dev_ex(buf, len);
        case TLV_LED_Power:
            return read_power(buf, len);
        case TLV_LED_Light:
            return read_light(buf, len);
        case TLV_LED_Dev_Info:
            return read_dev_info(buf);
        case TLV_LED_pgm_flicker:
            return read_pgm_flicker(buf);
        case TLV_LED_Rotate:
            return { rotate: buf[0]};
        case TLV_LED_bluetooth: {
            if (len == 0)
                return { cmd: "failed", errcode: 0x6F };
            else if (len == 2)
                return { bluetooth: { type: buf[0], val: buf[1] } };
            else
                return null;
        }
        case TLV_LED_pgm_key: {
            if (len < 21) {
                if (len == 5 && buf[0] == 255) {
                    var ts = bytes_deal_1.bytes_read_int(buf, 1, 4);
                    return { pgm_key: { ts_key: ts } };
                }
                return { pgm_key: [] };
            }
            var index = 0;
            var arr_pgm = [];
            while (index <= len - 21) {
                var key_buf = new Uint8Array(buf, index + 1, 20);
                var strkey = bytes_deal_1.bytes_to_hex(key_buf, "");
                var item = { id_pro: buf[index] + 1, key: strkey };
                arr_pgm.push(item);
                index += 21;
            }
            return { pgm_key: arr_pgm };
        }
        case TLV_LED_pgm_play: {
            if (len < 2)
                return { pgm_play: null };
            var arr = [];
            for (var i = 2; i < len; i++)
                arr.push(buf[i]);
            return { pgm_play: { model: buf[0], index: buf[1], ids_pro: arr } };
        }
        default:
            return null;
    }
}
exports.read_param = read_param;
function parse_ack(buf) {
    var len = buf.length;
    if (len < Size_Min_Ack_Pkt_Tlv)
        return null;
    if (bytes_deal_1.bytes_read_int(buf, 0, 2, false) != LED_Head_TLV)
        return null;
    var len_data_0 = bytes_deal_1.bytes_read_int(buf, 4, 2, false);
    if (len_data_0 > len - 6)
        return null;
    var sno = bytes_deal_1.bytes_read_int(buf, 6, 2, false);
    var bChecksum = (buf[8] >> 7) == 1 && (len >= 12);
    var len_cs = bChecksum ? 2 : 0;
    var ret;
    if (Size_Min_Ack_Pkt_Tlv == len)
        ret = { cmd: "failed", "errcode": ACK_TLV_ERR_Unknown };
    else if (buf[9] == TYPE_CMD_TLV_Ack + TYPE_CMD_TLV_Set || buf[9] == TYPE_CMD_TLV_Ack + TYPE_CMD_TLV_Upgrade) {
        if (0 == buf[10])
            ret = { cmd: "ok" };
        else
            ret = { cmd: "failed", "errcode": buf[10] };
    }
    else if (buf[9] == TYPE_CMD_TLV_Ack + TYPE_CMD_TLV_Get) {
        if (Size_Min_Ack_Pkt_Tlv == len)
            ret = { cmd: "failed", "errcode": ACK_TLV_ERR_Unknown };
        else if (len >= Size_Min_Ack_Get_Pkt_Tlv) {
            var len_data = len - 12 - len_cs;
            if (buf[11] == len_data)
                ret = read_param(buf[10], buf.slice(12, 12 + len_data), len_data);
        }
    }
    else if (buf[9] == TYPE_UPLOAD && buf[10] == TYPE_UPLOAD_GAME_Info) {
        var len_data = len - 12 - len_cs;
        if (len_data != 5)
            return null;
        var id = buf[12] - 0x80;
        var score = bytes_deal_1.bytes_read_int(buf, 13, 4);
        return { game_info: { id: id, score: score }, sno: sno };
    }
    return { ack: ret, sno: sno };
}
exports.parse_ack = parse_ack;
